import { useQuery } from '@tanstack/react-query'
import { getRequest } from 'api'

interface Params {
  deviceId: string
  requestId: string | undefined
}

const useFetchRequest = (params: Params) => {
  const { deviceId, requestId } = params
  return useQuery<any, Error>(['request', params], () => {
    if (requestId) {
      return getRequest(deviceId, parseInt(requestId, 10))
    }
    return Promise.reject(new Error('Invalid request ID'))
  })
}

export default useFetchRequest
